import type { Dispatch as ReduxDispatch } from '@reduxjs/toolkit';
import type { BaseAction } from '../@types/actions';

export const RCV_ROUTING = 'RCV/ROUTING';
type RCV_ROUTING_TYPE = BaseAction<typeof RCV_ROUTING> & {
  path: string;
};

export type ROUTING_ACTION = RCV_ROUTING_TYPE;

type Dispatch = ReduxDispatch<ROUTING_ACTION>;

export const silentRoute = (path: string) => (dispatch: Dispatch) => {
  dispatch({ type: RCV_ROUTING, path });
};
